import { KeyFacet, subKeyPart } from '@ms/items-view/lib/private/models/KeyFacet';
import { driveItemKeyFacet } from './DriveItemKeyFacet';

export const driveActivityItemKeyFacet: KeyFacet<{
  driveItemKey: {
    endpoint: string;
    driveId?: string;
    itemId?: string;
  };
}> = new KeyFacet('driveActivityItem', {
  driveItemKey: subKeyPart(driveItemKeyFacet)
});
